import { BlobPicture } from "../Models/BlobPicture";
import { IOnlineStorage } from "./IOnlineStorage";


export class OnlineStorage implements IOnlineStorage
{
    public Url = 'https://dropbox.specteam.pl';

    public async SaveBlob(picture: BlobPicture, fileName: string, folder: string): Promise<boolean>
    {
        try
        {
            // console.log(`Uploading to ${folder}/${fileName}...`);

            const formData = new FormData();
            formData.append('file', picture.Image, fileName);
            formData.append('folder', folder);

            const response = await fetch(this.Url, {
                method: 'POST',
                body: formData,
            });

            const isUploadSuccess = response.status == 200;

            return isUploadSuccess;
        }
        catch (ex)
        {
            console.error('File upload problem:', ex.message);
            return false;
        }
    }
}
